export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.table_label_originalFileName') || '原始文件名',
    field: 'originalFileName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 260,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_processFlag') || '文件处理标记',
    field: 'processFlag',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'processFlag' }
  },
  {
    title: that.$l('INDEX.table_label_processMessage') || '处理结果',
    field: 'processMessage',
    headerAlign: 'center',
    align: 'left',
    minWidth: 270,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_processDatetime') || '文件处理时间',
    field: 'processDatetime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_uploadBy') || '上传人',
    field: 'createdByName',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_uploadDate') || '上传时间',
    field: 'creationTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
